import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useI18n } from "../../../i18n";
import { fmtMoney } from "../../../lib/format";

export const NAVY = "#002068";
export const GREEN = "#98D028";
export const BLUE = "#0080FF";

const monthLabel = (m, lang) =>
  new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "el-GR", { month: "short", timeZone: "UTC" }).format(new Date(`${m}-15T12:00:00Z`));

const compact = (v) => (v >= 1000 ? `${Math.round(v / 100) / 10}k` : `${Math.round(v)}`);

export const MonthlyChart = ({ data, amounts }) => {
  const { t, lang } = useI18n();
  const rows = data.map((p) => ({ label: monthLabel(p.month, lang), cur: amounts ? p.value : p.qty, prev: amounts ? p.prev_value : p.prev_qty }));
  const fmt = (v) => (amounts ? fmtMoney(v) : t("insights.boxes", { n: v }));
  return (
    <div className="h-64 w-full" data-testid="chart-monthly">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={rows} margin={{ top: 8, right: 4, left: -12, bottom: 0 }} barGap={2}>
          <CartesianGrid vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="label" tickLine={false} axisLine={false} tick={{ fontSize: 11, fill: "#64748B" }} interval={0} />
          <YAxis tickLine={false} axisLine={false} tick={{ fontSize: 11, fill: "#64748B" }} tickFormatter={compact} width={44} />
          <Tooltip formatter={(v) => fmt(v)} cursor={{ fill: "rgba(0,32,104,0.05)" }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="prev" name={t("insights.previous")} fill={BLUE} fillOpacity={0.55} radius={[4, 4, 0, 0]} isAnimationActive={false} />
          <Bar dataKey="cur" name={t("insights.current")} fill={NAVY} radius={[4, 4, 0, 0]} isAnimationActive={false} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export const ShareBars = ({ rows, amounts, label, testId }) => {
  const { t } = useI18n();
  const val = (r) => (amounts ? r.value : r.qty);
  const max = Math.max(1, ...rows.map(val));
  return (
    <ul className="space-y-2.5" data-testid={testId}>
      {rows.map((r, i) => (
        <li key={r.key}>
          <div className="flex justify-between gap-2 text-sm">
            <span className="truncate text-navy">{label(r.key)}</span>
            <span className="shrink-0 font-semibold tabular-nums text-navy">{amounts ? fmtMoney(r.value) : t("insights.boxes", { n: r.qty })}</span>
          </div>
          <div className="mt-1 h-2 overflow-hidden rounded-full bg-slate-100">
            <div className="h-full rounded-full" style={{ width: `${(val(r) / max) * 100}%`, background: i === 0 ? BLUE : NAVY }} />
          </div>
        </li>
      ))}
    </ul>
  );
};
